import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { resetTradeIdices } from "../../../domestic/trades/tradesUXSlice";
import { PageIndex } from "../../../models";
import { setTradesIndexThunk } from "../thunks/loadSumTrades";

export const useTradeSumIndex = () => {
  const pageIndex = useSelector<StoreType, PageIndex>((s) => s.ux.domestic.trades.index);

  const dispatch = useDispatch();
  const dispatchSetIndex = React.useCallback(
    (index: PageIndex) => dispatch(setTradesIndexThunk(index)),
    [dispatch]
  );
  const dispatchResetIndex = React.useCallback(
    () => dispatch(resetTradeIdices()),
    [dispatch]
  );

  return [pageIndex, dispatchSetIndex, dispatchResetIndex] as [
    typeof pageIndex,
    typeof dispatchSetIndex,
    typeof dispatchResetIndex
  ];
};
